import axios from 'axios';
import api from './api';

export interface PerfilDTO {
  telefone: string;
  nome: string;
  endereco: {
    rua: string;
    numero: string;
    bairro: string;
    cidade: string;
    estado: string;
    cep: string;
    complemento?: string;
  };
  formaPagamento?: string;
}

export const getPerfil = async (telefone: string): Promise<PerfilDTO | null> => {
  try {
    const telefoneDigits = telefone.replace(/\D/g, '');

    if (!telefoneDigits) {
      return null;
    }

    const response = await api.get('/admin/perfil', {
      params: { telefone: telefoneDigits },
    });
    return response.data as PerfilDTO;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const salvarPerfil = async (perfil: PerfilDTO): Promise<PerfilDTO> => {
  const payload: PerfilDTO = {
    ...perfil,
    telefone: perfil.telefone.replace(/\D/g, ''),
  };

  const response = await api.post('/admin/perfil', payload);

  return response.data as PerfilDTO;
};
